import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { AdminAuthState, AdminUser } from '@/types/admin.types';

const ADMIN_SESSION_DURATION = 30 * 60 * 1000; // 30 minutes in milliseconds

const initialState: AdminAuthState = {
  isAuthenticated: false,
  admin: null,
  sessionExpiresAt: null,
};

const adminAuthSlice = createSlice({
  name: 'adminAuth',
  initialState,
  reducers: {
    loginSuccess: (state, action: PayloadAction<{ admin: AdminUser; expiresIn: number }>) => {
      state.isAuthenticated = true;
      state.admin = action.payload.admin;
      state.sessionExpiresAt = Date.now() + action.payload.expiresIn;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.admin = null;
      state.sessionExpiresAt = null;
    },
    refreshSession: (state) => {
      if (state.isAuthenticated) {
        state.sessionExpiresAt = Date.now() + ADMIN_SESSION_DURATION;
      }
    },
    checkSession: (state) => {
      if (state.sessionExpiresAt && Date.now() > state.sessionExpiresAt) {
        state.isAuthenticated = false;
        state.admin = null;
        state.sessionExpiresAt = null;
      }
    },
  },
});

export const { loginSuccess, logout, refreshSession, checkSession } = adminAuthSlice.actions;
export default adminAuthSlice.reducer;
